module.exports = __webpack_public_path__ + "img/t1-gray.32c1e96b.png";